import React from 'react';
import classnames from 'classnames';

import ubBanzai from 'ub/control/banzai-features';
import PageHeightWarning from './page-height-warning';
import RootDisplayPositionControls from './root-display-position-controls';

import styles from './inline-root-controls.scss';

const rxUi = window.rxUi;

// This is the minimum width where both controls can fit side-by-side.
const NARROW_LAYOUT_WIDTH = 780;

export default class InlineRootControls extends React.Component {
  constructor() {
    super();

    this.state = {visible: false};

    this.handleEditorLayoutChange = this.handleEditorLayoutChange.bind(this);
    this.handleDisplayPositionChange = this.handleDisplayPositionChange.bind(this);
  }

  handleEditorLayoutChange() {
    const {page, mainPage} = this.props.editor;

    const rootElement = page ? page.getRootElement() : null;
    const mainPageRootElement = mainPage ? mainPage.getRootElement() : null;

    if (rootElement && mainPageRootElement) {
      this.setState({
        breakpointName: page.getCurrentBreakpoint().name,
        currentPosition: mainPageRootElement.isDisplayPositionBottom() ? 'bottom' : 'top',
        heightWarningVisible: page.getConfigValue('showPageHeightWarning') && page.isMain(),
        pageDimensions: page.getDimensions(),
        positionControlsVisible:
          ubBanzai.features.isRootDisplayPositionControlsEnabled() &&
          page.getConfigValue('showRootDisplayPositionControls') &&
          page.isMain() &&
          page.isDesktopBreakpoint() &&
          rootElement.hasSections(),
        // There's a timing issue where querying top using `getOffset()` or `offsetTop` doesn't
        // return the value set by the editor `updateCanvasLayout` method immediately before this
        // handler is called, so we need to query the CSS property directly.
        rootTopOffset: parseInt(rootElement.view.e.style.top, 10),
        visible: true,
      });
    }
  }

  handleDisplayPositionChange(displayPosition) {
    this.uiBinding.onNext({type: 'setDisplayPosition', displayPosition});
  }

  componentDidMount() {
    this.props.editor.addListener('layoutChanged', this.handleEditorLayoutChange);

    this.uiBinding = new rxUi.Binding('InlineRootControls');
    this.uiBinding
      .filterByEventType('setDisplayPosition')
      .ub_subscribe((ev) => {
        const {page} = this.props.editor;
        const rootElement = page.getRootElement();

        if (rootElement) {
          rootElement.model.set('displaySettings.position', ev.displayPosition, page.undoManager);
        }
      });
  }

  componentWillUnmount() {
    this.props.editor.removeListener('layoutChanged', this.handleEditorLayoutChange);
    this.uiBinding.dispose();
  }

  render() {
    const {
      breakpointName,
      currentPosition,
      heightWarningVisible,
      pageDimensions,
      positionControlsVisible,
      rootTopOffset,
      visible,
    } = this.state;

    if (!visible) {
      return null;
    }

    const className = classnames(styles.container, styles[currentPosition], {
      [styles.narrow]: pageDimensions.width < NARROW_LAYOUT_WIDTH
    });

    const style = {
      width: pageDimensions.width,
      top: (currentPosition === 'top' ? rootTopOffset + pageDimensions.height : rootTopOffset) || 0
    };

    return (
      <div className={className} style={style}>
        {positionControlsVisible &&
          <div className={styles.displayPositionControls}>
            <RootDisplayPositionControls
              value={currentPosition}
              onChange={this.handleDisplayPositionChange}
            />
          </div>
        }

        {heightWarningVisible &&
          <div className={styles.heightWarning}>
            <PageHeightWarning breakpointName={breakpointName} pageHeight={pageDimensions.height} />
          </div>
        }
      </div>
    );
  }
}

InlineRootControls.propTypes = {
  editor: React.PropTypes.shape({
    page: React.PropTypes.shape({getRootElement: React.PropTypes.func.isRequired}),
    mainPage: React.PropTypes.shape({getRootElement: React.PropTypes.func.isRequired}),
    addListener: React.PropTypes.func.isRequired,
    removeListener: React.PropTypes.func.isRequired,
  }).isRequired,
};



// WEBPACK FOOTER //
// ./src/ui/components/inline-root-controls.jsx